export default "__VITE_ASSET__BQT_UjPa__"